import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class ProfileDefaultGuard {
  constructor(private authenticationService: AuthenticationService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authenticationService.getPlanFeaturesEnabled().pipe(
      map(plan => {
        const logisticsEnabled = plan?.default_skin === 'logistics' &&
          Array.isArray(plan?.available_dashboard_skins) &&
          plan.available_dashboard_skins.includes('logistics');
        return logisticsEnabled
          ? this.router.createUrlTree(['/profile', route.paramMap.get('id'), 'logistics'], {
              queryParams: route.queryParams,
              fragment: route.fragment,
            })
          : true;
      }),
      catchError(() => of(true))
    );
  }
}
